import type { HTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

export type BadgeTone = 'neutral' | 'accent' | 'success';

const TONES: Record<BadgeTone, string> = {
  neutral: 'bg-inset text-muted',
  accent: 'bg-accent-soft text-accent-text',
  success: 'bg-success/10 text-success',
};

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
}

export function Badge({ tone = 'neutral', className, ...rest }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-medium tracking-wide',
        TONES[tone],
        className,
      )}
      {...rest}
    />
  );
}
